import { images } from "../../../Assets/assetsHelper";
import AddStudentForm from "../../../Components/Organisms/Forms/AddStudnetForm/AddStudentForm";
import { useNavigate } from "react-router";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

function AddStudent({ Edit = false, student = null, loading = false, url }) {
  const navigate = useNavigate();

  return (
    <div className="mainContainer">
      <Card className="modernFormCard">
        <CardContent className="modernFormCardContent">
          <div className="formHeader">
            <div className="titleIcon">
              <PersonIcon />
            </div>
            <div className="titleContent">
              <h1>{Edit ? "Edit Student Information" : "Add New Student"}</h1>
            </div>
          </div>

          <div className="formDivider"></div>

          <Box className="modernFormWrapper">
            {loading && Edit ? (
              <div className="loadingBox">
                <CircularProgress />
              </div>
            ) : (
              <AddStudentForm Edit={Edit} student={student} url={url} />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Modern Footer Section */}
      <div className="modernFooterSection">
        <Typography variant="body2" className="footerText">
          {Edit
            ? "Make sure all information is accurate before saving changes."
            : "Please fill in all required fields to create the student profile."}
        </Typography>
      </div>
    </div>
  );
}

export default AddStudent;
